// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9061f5d7","453":"ef0ae604","732":"2ba836d1","977":"8ab7d970"}[chunkId] + ".chunk.js";
};